<template>
  <v-dialog
    v-model="dialogValue"
    persistent
    max-width="480"
    @click:outside.stop
  >
    <v-card>
      <v-card-text class="text-body-1 font-weight-bold pt-6">
        担当外の相談です。本当に送信しますか？
        <div class="text-caption font-weight-regular mt-1">
          ※送信する場合は「はい」を1秒以上長押ししてください
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          @click="onCancel"
        >
          いいえ
        </v-btn>
        <v-btn
          color="warning"
          variant="flat"
          v-bind="longPress.bind"
        >
          はい（送信する）
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useLongPress } from "../../../composables/useLongPress";

type Props = {
  /** ダイアログの開閉状態（v-model:open） */
  open: boolean;
};

const props = defineProps<Props>();

const emit = defineEmits<{
  "update:open": [boolean];
  confirm: [];
  cancel: [];
}>();

const dialogValue = computed({
  get: () => props.open,
  set: (value: boolean) => emit("update:open", value),
});

const onCancel = (): void => {
  emit("cancel");
  emit("update:open", false);
};

const onConfirm = (): void => {
  emit("confirm");
  emit("update:open", false);
};

const longPress = useLongPress(onConfirm);
</script>
